import { Link, NavLink } from 'react-router-dom'

import { useIsMobile } from '../../hooks/useIsMobile/useIsMobile'

import { Icon, Menu } from '@percent/lemonade'
import { useAuth } from '@percent/workplace-giving/common/hooks/useAuth/useAuth'
import {
  getAccountFromAuthState,
  getPartnerFromAuthState
} from '@percent/workplace-giving/context/auth/authContextController/AuthContextController'
import { AppRoute } from '@percent/workplace-giving/routing/AppRoute.enum'
import { ActionsMenu } from './ActionsMenu/ActionsMenu'
import { MobileNavBar } from './MobileNavBar'
import { useNavigationItems } from './useNavigationItems'
import classes from './NavBar.module.scss'
import { SpotlightSearch } from './SpotlightSearch/SpotlightSearch'

export const addEllipsis = (str: string, totalChar: number) => {
  return str?.length < totalChar ? str : `${str?.substring(0, totalChar)}...`
}

export function NavBar() {
  const authState = useAuth()
  const account = getAccountFromAuthState(authState.state)!
  const partner = getPartnerFromAuthState(authState.state)!
  const isMobile = useIsMobile()
  const { navLinks, menuSections } = useNavigationItems()

  const partnerLogo = partner.configLogo || partner.logo
  const accountName =
    addEllipsis(account?.preferredName ?? '', 50) || addEllipsis(account?.fullName ?? '', 50) || 'Account'

  if (!account) {
    return (
      <div className={classes.navBarWrapper}>
        <div className={classes.navBarInnerWrapper}>
          {partnerLogo ? (
            <div className={classes.logoWrapper}>
              <Link to={AppRoute.HOME}>
                <img src={partnerLogo} alt={`${partner.name} logo`} />
              </Link>
            </div>
          ) : null}
        </div>
      </div>
    )
  }

  if (isMobile) {
    return (
      <MobileNavBar
        accountName={accountName}
        menuSections={menuSections}
        navLinks={navLinks}
        partnerLogo={partnerLogo}
        partnerName={partner.name}
      />
    )
  }

  return (
    <div className={classes.navBarWrapper}>
      <div className={classes.navBarInnerWrapper}>
        {partnerLogo ? (
          <div className={classes.logoWrapper}>
            <Link to={AppRoute.HOME}>
              <img src={partnerLogo} alt={`${partner.name} logo`} />
            </Link>
          </div>
        ) : null}

        <div className={classes.navBarLinksWrapper}>
          {navLinks.map(link => (
            <NavLink key={link.key} to={link.to} end={link.end}>
              {link.label}
            </NavLink>
          ))}

          <div className={classes.actionButtonsWrapper}>
            <ActionsMenu />
            <SpotlightSearch />
          </div>

          <div className={classes.accountMenuWrapper}>
            <Menu
              customTriggerComponent={
                <button className={classes.menuButton} data-testid="account-menu" type="button">
                  <span>{accountName}</span>
                  <Icon name="dropdown-arrow-down" color="gray500" size={6} />
                </button>
              }
              sections={menuSections}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
